import React from 'react';
import { AlertTriangle, RefreshCw, Lock } from 'lucide-react';
export function ProblemSection() {
  return <section className="relative py-12 md:py-24 bg-[#060d16] overflow-hidden" data-id="element-205">
      {/* Grid Background */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:20px_20px] opacity-20" data-id="element-206" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-207">
        <div className="max-w-3xl mx-auto text-center mb-8 md:mb-16" data-id="element-208">
          <h2 className="text-3xl md:text-5xl font-bold mb-6 text-[#c8c0b0]" data-id="element-209">
            <span className="text-[#00d4ff] glow-text-cyan" data-id="element-210">System Error:</span>{' '}
            The Infinite Loop
          </h2>
          <p className="text-lg text-[#c8c0b0]/80 leading-relaxed" data-id="element-211">
            Have you ever felt like your life is repeating itself? The same
            toxic relationships, the same financial walls, the same feeling of
            emptiness when you wake up?
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8" data-id="element-212">
          {[{
          icon: RefreshCw,
          title: 'Cyclic Repetition',
          desc: 'You are trapped in a Fractal—an infinite geometric repetition that governs your reality without you even realizing it.'
        }, {
          icon: Lock,
          title: 'The Simulation',
          desc: 'From the day you were born, you were placed inside a simulation. Just like fractals repeat at every scale, your life has been repeating in cycles of struggle.'
        }, {
          icon: AlertTriangle,
          title: 'Symptom Management',
          desc: 'The system taught you to fight the symptoms: the stress, the fear. But it never showed you the invisible fractal that generates those patterns.'
        }].map((item, i) => <div key={i} className="bg-[#0a1520] border border-[#c8c0b0]/10 p-5 md:p-8 rounded-lg hover:border-[#00d4ff]/50 transition-colors duration-300 group" data-id="element-213">
              <div className="w-12 h-12 bg-[#00d4ff]/10 rounded-lg flex items-center justify-center mb-4 md:mb-6 group-hover:bg-[#00d4ff]/20 transition-colors" data-id="element-214">
                <item.icon className="w-6 h-6 text-[#00d4ff]" data-id="element-215" />
              </div>
              <h3 className="text-xl font-bold text-[#c8c0b0] mb-3 font-serif" data-id="element-216">
                {item.title}
              </h3>
              <p className="text-[#c8c0b0]/60 text-sm leading-relaxed" data-id="element-217">
                {item.desc}
              </p>
            </div>)}
        </div>

        <div className="mt-8 md:mt-16 text-center" data-id="element-218">
          <div className="inline-block p-4 md:p-6 border border-[#c9a84c]/30 bg-[#c9a84c]/5 rounded max-w-2xl" data-id="element-219">
            <p className="text-[#c9a84c] font-mono text-sm md:text-base" data-id="element-220">
              "You've been trying to change the image on the screen without
              touching the projector."
            </p>
          </div>
        </div>
      </div>
    </section>;
}